import { getShopData } from "../../lib/loadShopData";

// components/Checkout/bmlPayment.ts
// export const BML_CONFIG = {
//   merchantId: 'YOUR_MERCHANT_ID',
//   apiKey: 'YOUR_API_KEY',
//   gatewayUrl: 'https://bml.com/payment/gateway',
//   testGatewayUrl: 'https://test.bml.com/payment/gateway',
//   isTestMode: true,
//   returnUrl: window.location.origin + '/payment/success',
//   cancelUrl: window.location.origin + '/payment/cancel',
// };

const apiUrl = import.meta.env.VITE_API_URL ?? "https://api.vehidhi.com";

export const processBMLPayment = async (
  amount: number,
  orderId: string,
  customerData: any
) => {
  try {
    const response = await fetch(
      `${apiUrl}/payments/bml/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          amount,
          reference: orderId,
          localId: orderId,
          customerReference:
            customerData.customerReference ||
            customerData.email ||
            customerData.phone,
        }),
      }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to create BML payment");
    }

    return {
      success: true,
      redirectUrl: data.paymentUrl,
      transactionId: data.transactionId,
      state: data.state,
      localId: data.localId,
      customerReference: data.customerReference,
    };
  } catch (error) {
    console.error("BML Payment Error:", error);
    throw error;
  }
};